import { HIDE_REFERENCE_RELEASE_COMPOSER, SHOW_REFERENCE_RELEASE_COMPOSER } from 'actions/joborder';

/**
 * @param {JobOrderProfileState} [state]
 * @param {Action} [action]
 * @returns {JobOrderProfileState}
 */
const jobOrderReducer = (state = {}, action = { type: '', payload: {} }) => {
  const { type, payload } = action;
  switch (type) {
    case SHOW_REFERENCE_RELEASE_COMPOSER:
      return {
        ...state,
        referenceRelease: payload
      };
    case HIDE_REFERENCE_RELEASE_COMPOSER:
      return {
        ...state,
        referenceRelease: null
      };
    default:
      return state;
  }
};

export default jobOrderReducer;
